<template>
  <div class="player-poster">
    <span :style="{ position: 'relative' }">
      <img
        class="avatar"
        :src="getImage()"
        @click="clickPoster('poster_avatar')"
      >
      <JumpMiniApp
        v-if="miniAppPathClickPerson"
        :path="miniAppPathClickPerson"
        @launch="clickPoster('poster_avatar', true)"
      />
    </span>
    <div
      class="username"
      @click="clickPoster('poster_nick')"
    >
      {{ nickInfo }}
      <JumpMiniApp
        v-if="miniAppPathClickPerson"
        :path="miniAppPathClickPerson"
        @launch="clickPoster('poster_nick', true)"
      />
    </div>
    <div
      v-if="!isMe && showFocus"
      class="focus"
      @click="clickPoster('poster_follow')"
    >
      <JumpMiniApp
        v-if="miniAppPathClickFollow"
        :path="miniAppPathClickFollow"
        @launch="clickPoster('poster_follow', true)"
      />关注
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { fixHttps } from '@/utils/no-import-meta/url';
import { transferUbbToImg, encodeHtml } from '@/utils/string';
import { ModelMetaFeed } from '@/types/Model';
import JumpMiniApp from './jump-mini-app.vue';

const baseAvatarUrl = 'https://q.qlogo.cn/qqapp/1101083114/0/100';
const enum EEmitEvent {
  onClickPoster = 'on-click-poster',
}

export default defineComponent({
  name: 'PlayerPoster',
  components: {
    JumpMiniApp,
  },
  props: {
    miniAppPathClickFollow: {
      type: String,
      default: '',
    },
    miniAppPathClickPerson: {
      type: String,
      default: '',
    },
    feed: {
      type: Object as PropType<ModelMetaFeed>,
      default: () => ({}),
    },
    showFocus: {
      type: Boolean,
      default: true,
    },
    isMe: {
      type: Boolean,
      default: false,
    },
  },
  emits: [EEmitEvent.onClickPoster],
  data() {
    return {
      baseAvatarUrl,
      nickInfo: '',
    };
  },
  computed: {
    poster() {
      return (this.feed?.poster) || {};
    },
  },
  created() {
    this.nickInfo = this.poster.nick || `微视用户${this.feed.posterId || ''}`;
  },
  mounted() {
    // transferUbbToImg只能在CSR阶段中执行
    this.nickInfo = transferUbbToImg(encodeHtml(this.nickInfo));
  },
  methods: {
    getImage() {
      return fixHttps(this.poster?.avatar || this.baseAvatarUrl);
    },
    clickPoster(tag: string, clickMiniApp = false) {
      this.$emit(EEmitEvent.onClickPoster, tag, clickMiniApp);
    },
  },
});
</script>

<style lang="scss" scoped>

.player-poster {
  position: relative;
  display: flex;
  align-items: center;
  .avatar {
    box-sizing: border-box;
    flex-grow: 0;
    flex-shrink: 0;
    @include responsiveStyleSingle(flex-basis, 10.9333, 'vw');
    @include responsiveStyleSingle(height, 10.9333, 'vw');
    @include responsiveStyleSingle(margin-right, 0.9333, 'vw');
    border-color: hsla(0, 0%, 100%, 0.2);
    border-style: solid;
    @include responsiveStyleSingle(border-width, 0.6667,'vw');
    border-radius: 50%;
  }
  .username {
    position: relative;
    @include responsiveStyleSingle(margin-right, 1, 'vw');
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    @include responsiveStyleSingle(font-size, 3.4667, 'vw');
    font-weight: bold;
  }
  .focus {
    position: relative;
    flex-grow: 0;
    flex-shrink: 0;
    @include responsiveStyleSingle(flex-basis, 10.1333, 'vw');
    @include responsiveStyleSingle(height, 5.8667, 'vw');
    @include responsiveStyleSingle(line-height, 5.8667, 'vw');
    text-align: center;
    @include responsiveStyleSingle(font-size, 3.2, 'vw');
    font-weight: bold;
    background: #7a46ff;
    @include responsiveStyleSingle(border-radius,2.9333, 'vw');
  }
}
</style>
